import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const createTestCookie = createAsyncThunk(
  "consent/cookie",
  async (data) => {
    const response = await api.post("consent/cookie", data);
    return response.data;
  }
);

export const updateCookie = createAsyncThunk(
  "consent/log",
  async (data) => {
    const response = await api.post("consent/log", data);
    return response.data;
  }
);